var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"account_top_header"}},[_c('span',{staticClass:"name_title"},[_vm._v(_vm._s(_vm.title))]),(_vm.icon)?_c('img',{staticClass:"logo-header",attrs:{"src":_vm.icon,"alt":""}}):_c('img',{staticClass:"title-img",attrs:{"src":require("@/assets/images/wallet/bgr-wallet.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }